import React, { useRef, useState } from 'react';
import UserAvatarImage from '../../../Components/UserAvatar/UserAvatarImage';
import { UserAvatarImageType } from '../../../Enums/UserAvatarImageType.enum';
// @ts-ignore
import styles from './CaseChatPatientIsTyping.module.scss';
import useSocket from '../../Base/Hooks/useSocket';
import { Socket } from '../../Base/Enums/Socket.enum';

interface Props {
	patientId: string;
	caseId: string;
	profileImageUrl?: string;
	scrollChat: () => void;
}

const CaseChatPatientIsTyping: React.FC<Props> = ({
	patientId,
	caseId,
	profileImageUrl,
	scrollChat,
}) => {
	const [isPatientTyping, setIsPatientTyping] = useState(false);
	const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

	const handleTyping = (data: { caseId: string; userId: string }) => {
		if (data.caseId === caseId && data.userId === patientId) {
			setIsPatientTyping(true);
			scrollChat();

			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}

			timeoutRef.current = setTimeout(() => {
				setIsPatientTyping(false);
			}, 1000);
		}
	};

	useSocket(Socket.USER_TYPING, handleTyping);

	if (!isPatientTyping) {
		return <></>;
	}

	return (
		<div className='chat-message d-flex'>
			<div className='message-text case-detail-chat-window__message-wrapper flex-shrink-1 rounded py-2 ml-4 pr-4 pl-5'>
				<div className='chat-profile-image'>
					<UserAvatarImage
						userId={patientId}
						profileImageUrl={profileImageUrl}
						type={UserAvatarImageType.BACKGROUND}
						customClass={'profile-photo profile-photo__message'}
					/>
				</div>
				<div className='chat-message__content'>
					<div className='chat-message__message'>
						<div className={styles.loader} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default CaseChatPatientIsTyping;
